module.exports = __webpack_public_path__ + "img/21.92d8dd3.webp";